export const appAppleStoreLink = 'https://apps.apple.com/us/app/circleof-caregiver-support/id1298712207';
export const appGoogleStoreLink = 'https://play.google.com/store/apps/details?id=com.mywaysmobile';

export const featureFlags = {
  financeMegaCategoryEnabled: true,
  // https://circleof.atlassian.net/browse/APP-2939
  facilitySubcategoryEnabled: false,
  // https://circleof.atlassian.net/browse/MARK-117
  // https://circleof.atlassian.net/browse/APP-3179
  creditCardsSubcategoryEnabled: false,
  loansSubcategoryEnabled: false,
};
